import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { apiGet } from '../../../api';

class SendVoucher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      loading: false,
      showVoucherSent: false,
    };
    this.sendEmail = this.sendEmail.bind(this);
  }

  sendEmail(event) {
    event.preventDefault();
    this.setState({ loading: true, showVoucherSent: false });
    const url = `api-pb/voucher/send-email/${this.props.lang}/${this.props.locator}/${this.state.email}/`;
    apiGet(url).then(() => {
      this.setState({ loading: false, email: '', showVoucherSent: true });
    });
  }

  render() {
    return (
      <div className="SendVoucher">
        <h1>{this.context.t('Forward Voucher')}</h1>
        <form onSubmit={this.sendEmail}>
          <div className="form-group">
            <input
              disabled={this.state.loading}
              className="form-control"
              type="email"
              value={this.state.email}
              onChange={(event) => this.setState({ email: event.target.value })}
              required
              placeholder={this.context.t('Email')}
            />
          </div>
          <button
            className="btn btn-primary"
            disabled={this.state.loading || this.state.email === ''}>
            {this.state.loading
              ? this.context.t('Sending voucher...')
              : this.context.t('Send')}
          </button>
          {this.state.showVoucherSent
          && <div className="ml-1 text-success">{this.context.t('Voucher sent successfully')}</div>}
        </form>
      </div>
    );
  }
}

SendVoucher.contextTypes = {
  t: PropTypes.func.isRequired,
};

SendVoucher.propTypes = {
  locator: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
};

export default SendVoucher;
